import React from "react";
import cn from "classnames";
import styles from "./Create.module.sass";
import Icon from "../../../../../../components/Icon";
import TextInput from "../../../../../../components/TextInput";
import { create_tags_barcode } from "../../../../../../API/TagBarcode";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { message } from "antd";
import Card from "../../../../../../components/Card";
import { useNavigate } from "react-router";
import Panel from "../Panel";

const CreateBarcode = () => {
  const navigate = useNavigate();

  const initialValues = {
    tag_name: "",
  };

  const validationSchema = Yup.object({
    tag_name: Yup.string().required("Tag name is required"),
  });

  const handleSave = async (
    values,
    { setTouched, setErrors, validateForm }
  ) => {
    try {
      const errors = await validateForm();
      if (Object.keys(errors).length > 0) {
        setTouched({ tag_name: true });
        setErrors(errors);
        return;
      }

      const res = await create_tags_barcode(values);
      if (res.status === 201) {
        message.success(res.data.message);
        navigate("/settingsDashboard/camera&Barcode/actionBarcodesForTag");
      }
    } catch (error) {
      if (error.response?.status === 400) {
        message.error(Object.values(error.response.data.errors[0])[0]);
      } else {
        message.error("An error occurred while creating the barcode");
      }
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSave}
    >
      {({ isSubmitting }) => (
        <Form>
          <Card
            className={cn(styles.card)}
            title="Create Action Barcode for Tags"
            classTitle="title-purple"
            head={
              <button
                className={cn("button-stroke")}
                onClick={() =>
                  navigate(
                    "/settingsDashboard/camera&Barcode/actionBarcodesForTag"
                  )
                }
              >
                <Icon name="arrow-left" size="24" />
                <span>Back</span>
              </button>
            }
          >
            <div className={styles.description}>
              <Field name="tag_name">
                {({ field, meta }) => (
                  <TextInput
                    {...field}
                    label="Enter Tag"
                    tooltip="Maximum 50 characters."
                    className={cn(styles.field)}
                    error={meta.touched && meta.error ? meta.error : ""}
                    required
                  />
                )}
              </Field>
            </div>
          </Card>
          <div className="fixed bottom-7 left-30 right-5">
            <Panel />
          </div>
        </Form>
      )}
    </Formik>
  );
};
export default CreateBarcode;
